import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["ring"]
  static values = {
    total: Number,
    completed: Number
  }

  connect() {
    console.log("Connected")
    this.updateProgress()
  }

  updateProgress() {
    const radius = 10
    const circumference = 2 * Math.PI * radius

    const progress = Math.min(this.completedValue / this.totalValue, 1)
    console.log("progress", progress)

    const offset = circumference - progress * circumference

    this.ringTarget.style.strokeDasharray = `${circumference}`
    this.ringTarget.style.strokeDashoffset = offset
  }
}
